'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/react-dom/index.js
// module id = 112
// module chunks = 0